import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=1518d888"
import script from "./addBrand.vue?vue&type=script&lang=js"
export * from "./addBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports